import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { quoteDarkBgVars, quoteWhiteBgVars } from './QuoteV2.palette';

export const snapQuotePrimaryVars: MotifComponentProps<MotifComponent.QUOTE> = {
  ...quoteWhiteBgVars,
  '--quote-bg-color': m('--bg-color'),
  '--quote-box-shadow': 'none',
  '--quote-icon-desktop-font-size': '0px',
  '--quote-icon-desktop-line-height': '0px',
  '--quote-icon-desktop-margin-bottom': '0px',
  '--quote-icon-mobile-font-size': '0px',
  '--quote-icon-mobile-line-height': '0px',
  '--quote-icon-mobile-margin-bottom': '0px',
  '--quote-author-text-align': 'start',
  '--quote-card-left-right-padding': '0px',
} as const;

export const snapQuoteSecondaryVars: MotifComponentProps<MotifComponent.QUOTE> = {
  ...quoteDarkBgVars,
  '--quote-bg-color': m('--bg-color'),
  '--quote-box-shadow': 'none',
  '--quote-icon-desktop-font-size': '0px',
  '--quote-icon-desktop-line-height': '0px',
  '--quote-icon-desktop-margin-bottom': '0px',
  '--quote-icon-mobile-font-size': '0px',
  '--quote-icon-mobile-line-height': '0px',
  '--quote-icon-mobile-margin-bottom': '0px',
  '--quote-author-text-align': 'start',
  '--quote-card-left-right-padding': '0px',
} as const;

export const snapQuoteTertiaryVars: MotifComponentProps<MotifComponent.QUOTE> = {
  ...quoteWhiteBgVars,
  '--quote-bg-color': m('--bg-color'),
  '--quote-box-shadow': 'none',
  '--quote-icon-desktop-font-size': '0px',
  '--quote-icon-desktop-line-height': '0px',
  '--quote-icon-desktop-margin-bottom': '0px',
  '--quote-icon-mobile-font-size': '0px',
  '--quote-icon-mobile-line-height': '0px',
  '--quote-icon-mobile-margin-bottom': '0px',
  '--quote-author-text-align': 'start',
  '--quote-card-left-right-padding': '0px',
} as const;
